export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4785.24b3d55f.jpg";